/* ============================================================
   PSIQUEACTIVA · Asistente "Solicitar propuesta" (Empresas)
   5 pasos: interés → momento → tamaño y modalidad → contacto → gracias
   ============================================================ */
(function(){
  function init(){
    const body = document.getElementById('wizBody');
    const fill = document.getElementById('wizFill');
    const stepName = document.getElementById('wizStepName');
    const stepNum = document.getElementById('wizStepNum');
    if (!body) return;

    const ic = (p) => '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>';
    const check = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>';

    const ICONS = [
  ic('<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path>'),
  ic('<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>'),
  ic('<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>'),
  ic('<path d="M3 11l19-9-9 19-2-8-8-2z"></path>'),
  ic('<circle cx="12" cy="12" r="10"></circle><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path>')
];
function slug(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
function parseLines(txt){ return (txt||'').split(/\r?\n/).map(function(l){return l.trim();}).filter(Boolean); }
const WIZ = window.PSI_WIZ || {};
const INTERES = parseLines(WIZ.intereses).map(function(l,i){ var p=l.split('|'); return { v:slug(p[0]), l:p[0].trim(), d:(p[1]||'').trim(), icon:ICONS[i % ICONS.length] }; });
const MOMENTO = parseLines(WIZ.momentos).map(function(l){ var p=l.split('|'); return { v:slug(p[0]), l:p[0].trim(), d:(p[1]||'').trim() }; });
const TAMANO = parseLines(WIZ.tamanos).map(function(l){ return { v:slug(l), l:l }; });
const MODALIDAD = parseLines(WIZ.modalidades).map(function(l){ return { v:slug(l), l:l }; });
            
    const labelOf = (arr, v) => { const o = arr.find(x => x.v === v); return o ? o.l : v; };

    const STEPS = ['interes','momento','equipo','contacto','done'];
    const STEP_NAMES = { interes:'Lo que te interesa', momento:'El momento de tu equipo', equipo:'Tamaño y modalidad', contacto:'Tus datos', done:'¡Listo!' };
    const state = { step:0, interes:[], momento:[], tamano:null, modalidad:[],
                    empresa:'', nombre:'', cargo:'', correo:'', mensaje:'' };

    // Al volver de Shopify tras enviar, restaura la pantalla final.
    // Usamos psiPosted O la marca 'psiEmpresasSent' (por si el redirect no re-renderiza psiPosted).
    if (document.getElementById('psiPosted') || sessionStorage.getItem('psiEmpresasSent')){
      try {
        const saved = JSON.parse(sessionStorage.getItem('psiEmpresas') || 'null');
        sessionStorage.removeItem('psiEmpresas');
        sessionStorage.removeItem('psiEmpresasSent');
        if (saved){
          Object.assign(state, saved);
          state.step = STEPS.indexOf('done');
        }
      } catch(err){}
    }

    // Etiquetas de una lista de valores (multi)
    const labelsOf = (arr, vals) => (vals||[]).map(v => labelOf(arr, v)).join(', ');
    function toggle(list, v){ const i = list.indexOf(v); if(i>=0) list.splice(i,1); else list.push(v); }

    // Preselección por URL (?interes=talleres) o por hash de la página de origen
    try {
      const params = new URLSearchParams(location.search);
      const pre = params.get('interes');
      var hit = pre ? INTERES.find(function(x){return x.v===pre || x.v.indexOf(pre)===0;}) : null; if (hit) state.interes = [hit.v];
    } catch(e){}

    function setProgress(){
      const total = STEPS.length;
      fill.style.width = Math.round(((state.step+1)/total)*100) + '%';
      stepNum.textContent = state.step < total-1 ? ('Paso '+(state.step+1)+' de '+(total-1)) : 'Completado';
      stepName.textContent = STEP_NAMES[STEPS[state.step]];
      document.getElementById('wizProgress').style.display = (STEPS[state.step]==='done') ? 'none' : 'block';
    }

    function optBtn(o, selected){
      return '<button type="button" class="wopt'+(selected?' sel':'')+'" data-v="'+o.v+'">'
        + (o.icon ? '<span class="oic">'+o.icon+'</span>' : '')
        + '<span class="otx">'+o.l+(o.d?'<span>'+o.d+'</span>':'')+'</span>'
        + '<span class="ock">'+check+'</span></button>';
    }
    function segBtn(o, selected){
      return '<button type="button" class="wopt'+(selected?' sel':'')+'" data-v="'+o.v+'"><span class="otx">'+o.l+'</span></button>';
    }
    function navRow(opts){
      opts = opts || {};
      const back = state.step > 0 ? '<button type="button" class="wback" id="wBack">'+ic('<path d="M19 12H5M11 18l-6-6 6-6"></path>')+'Atrás</button>' : '';
      const nextLabel = opts.nextLabel || 'Continuar';
      const dis = opts.nextDisabled ? ' disabled' : '';
      return '<div class="wnav">'+back+'<div class="spacer"></div>'
        + '<button type="'+(opts.submit?'submit':'button')+'" class="btn btn-primary wbtn" id="wNext"'+dis+'>'+nextLabel
        + ic('<path d="M5 12h14M13 6l6 6-6 6"></path>')+'</button></div>';
    }

    function render(){
      setProgress();
      const s = STEPS[state.step];
      if (s === 'interes') return renderInteres();
      if (s === 'momento') return renderMomento();
      if (s === 'equipo')  return renderEquipo();
      if (s === 'contacto')return renderContacto();
      if (s === 'done')    return renderDone();
    }

    function renderInteres(){
      body.innerHTML = '<div class="wstep"><h3>¿Qué te interesa?</h3><p class="sub">Elige uno o varios programas. Si dudas, no pasa nada.</p>'
        + '<div class="wopts">'+INTERES.map(o => optBtn(o, state.interes.includes(o.v))).join('')+'</div>'
        + navRow({ nextDisabled: !state.interes.length })+'</div>';
      bindMulti((v)=>{ toggle(state.interes, v); enableNext(state.interes.length>0); });
      bindNav(()=>{ if(state.interes.length){ go(1); } });
    }
    function renderMomento(){
      body.innerHTML = '<div class="wstep"><h3>¿Cuál es el momento de tu equipo?</h3><p class="sub">Elige todo lo que aplique. Esto me ayuda a enfocar la propuesta en lo que de verdad necesitan.</p>'
        + '<div class="wopts">'+MOMENTO.map(o => optBtn(o, state.momento.includes(o.v))).join('')+'</div>'
        + navRow({ nextDisabled: !state.momento.length })+'</div>';
      bindMulti((v)=>{ toggle(state.momento, v); enableNext(state.momento.length>0); });
      bindNav(()=>{ if(state.momento.length){ go(1); } });
    }
    function renderEquipo(){
      body.innerHTML = '<div class="wstep"><h3>Tamaño y modalidad</h3><p class="sub">¿Cuántas personas participarían y cómo prefieres el encuentro? Puedes marcar varias modalidades.</p>'
        + '<div class="wfield" style="margin-bottom:20px;"><label>Tamaño del equipo</label><div class="wopts two">'+TAMANO.map(o => segBtn(o, state.tamano===o.v)).join('')+'</div></div>'
        + '<div class="wfield"><label>Modalidad</label><div class="wseg">'+MODALIDAD.map(o => segBtn(o, state.modalidad.includes(o.v))).join('')+'</div></div>'
        + navRow({ nextDisabled: !(state.tamano && state.modalidad.length) })+'</div>';
      // dos grupos: tamaño (single) y modalidad (multi)
      const groups = body.querySelectorAll('.wopts, .wseg');
      bindGroup(groups[0], (v)=>{ state.tamano=v; enableNext(state.tamano && state.modalidad.length); });
      bindMultiIn(groups[1], (v)=>{ toggle(state.modalidad, v); enableNext(state.tamano && state.modalidad.length); });
      bindNav(()=>{ if(state.tamano && state.modalidad.length){ go(1); } });
    }
    function renderContacto(){
      body.innerHTML = '<div class="wstep"><h3>¿Cómo te contacto?</h3><p class="sub">Con esto te envío una propuesta pensada para tu organización.</p>'
        + '<div class="wfield" data-req style="margin-bottom:16px;"><label for="wEmpresa">Empresa</label><input type="text" id="wEmpresa" name="contact[Empresa]" value="'+esc(state.empresa)+'" placeholder="Nombre de tu organización"><p class="emsg">Dime el nombre de tu empresa.</p></div>'
        + '<div class="wgrid2" style="margin-bottom:16px;">'
          + '<div class="wfield" data-req><label for="wNombre">Tu nombre</label><input type="text" id="wNombre" name="contact[Nombre]" value="'+esc(state.nombre)+'" placeholder="¿Con quién hablo?"><p class="emsg">Escríbeme tu nombre.</p></div>'
          + '<div class="wfield"><label for="wCargo">Cargo <span style="font-weight:500;color:var(--muted);">— opcional</span></label><input type="text" id="wCargo" name="contact[Cargo]" value="'+esc(state.cargo)+'" placeholder="Ej: RRHH, Gerencia"></div>'
        + '</div>'
        + '<div class="wfield" data-req data-email style="margin-bottom:16px;"><label for="wCorreo">Correo</label><input type="email" id="wCorreo" name="contact[email]" value="'+esc(state.correo)+'" placeholder="tucorreo@empresa.com"><p class="emsg">Revisa que el correo esté bien escrito.</p></div>'
        + '<div class="wfield"><label for="wMensaje">¿Algo más que quieras contarme? <span style="font-weight:500;color:var(--muted);">— opcional</span></label><textarea id="wMensaje" placeholder="Lo que tengas en mente.">'+esc(state.mensaje)+'</textarea></div>'
        + navRow({ submit:true, nextLabel:'Enviar solicitud' })+'</div>';
      bindNav(null); // submit handled by form
    }
    function renderDone(){
            const interesTxt = labelsOf(INTERES, state.interes);
      const momentoTxt = labelsOf(MOMENTO, state.momento);
      const modalidadTxt = labelsOf(MODALIDAD, state.modalidad);
      body.innerHTML = '<div class="wstep wdone">'
        + '<div class="check"><svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="oklch(0.46 0.058 158)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg></div>'
        + '<h3>¡Gracias, '+esc(state.nombre || 'gracias')+'!</h3>'
        + '<p>Recibí tu solicitud. Te escribo con una propuesta en menos de 48 horas hábiles.</p>'
        + '<div class="wsummary">'
          + '<div class="row"><span>Te interesa</span><span>'+interesTxt+'</span></div>'
          + '<div class="row"><span>Momento</span><span>'+momentoTxt+'</span></div>'
          + '<div class="row"><span>Equipo</span><span>'+labelOf(TAMANO, state.tamano)+' personas</span></div>'
          + '<div class="row"><span>Modalidad</span><span>'+(modalidadTxt||'—')+'</span></div>'
        + '</div>'
        + '<a href="https://wa.me/' + PSI_WA + '" target="_blank" rel="noopener" class="btn wa-btn" style="width:100%;">'+ic('<path d="M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-4-1L3 20l1-5.5a8.5 8.5 0 0 1 15.5-3.5z"></path>')+' ¿Es urgente? Escríbeme por WhatsApp</a>'
        + '</div>';
    }

    // ---- helpers ----
    function go(delta){ state.step = Math.max(0, Math.min(STEPS.length-1, state.step+delta)); render(); scrollTop(); }
    function enableNext(force){ const n = document.getElementById('wNext'); if(n) n.disabled = (force===undefined) ? false : !force; }
    function bindOpts(onPick){
      body.querySelectorAll('.wopt').forEach(b => b.addEventListener('click', () => {
        body.querySelectorAll('.wopt').forEach(x => x.classList.remove('sel'));
        b.classList.add('sel'); onPick(b.dataset.v);
      }));
    }
    function bindGroup(group, onPick){
      group.querySelectorAll('.wopt').forEach(b => b.addEventListener('click', () => {
        group.querySelectorAll('.wopt').forEach(x => x.classList.remove('sel'));
        b.classList.add('sel'); onPick(b.dataset.v);
      }));
    }
    // Multi-select: alterna .sel en el botón sin limpiar los demás
    function bindMulti(onToggle){
      body.querySelectorAll('.wopt').forEach(b => b.addEventListener('click', () => {
        b.classList.toggle('sel'); onToggle(b.dataset.v);
      }));
    }
    function bindMultiIn(group, onToggle){
      group.querySelectorAll('.wopt').forEach(b => b.addEventListener('click', () => {
        b.classList.toggle('sel'); onToggle(b.dataset.v);
      }));
    }
    function bindNav(onNext){
      const back = document.getElementById('wBack');
      if (back) back.addEventListener('click', () => go(-1));
      const next = document.getElementById('wNext');
      if (next && onNext) next.addEventListener('click', onNext);
    }
    function scrollTop(){ const y = document.querySelector('#propuesta').getBoundingClientRect().top + window.scrollY - 80; window.scrollTo({ top:Math.max(0,y), behavior:'smooth' }); }
    function esc(s){ return (s||'').replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c])); }

    // submit (en paso contacto). propForm ES ahora el formulario de contacto de Shopify:
    // la persona escribe en campos reales (contact[Empresa]/[Nombre]/[email]…) → el captcha se carga.
    // Enviamos NATIVO (sin preventDefault cuando es válido) para que Shopify adjunte el token.
    document.getElementById('propForm').addEventListener('submit', (e) => {
      if (STEPS[state.step] !== 'contacto'){ e.preventDefault(); return; }
      let ok = true;
      body.querySelectorAll('.wfield[data-req]').forEach(f => {
        const input = f.querySelector('input');
        const val = (input.value||'').trim();
        let bad = !val;
        if (f.hasAttribute('data-email') && val && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) bad = true;
        f.classList.toggle('err', bad);
        if (bad) ok = false;
      });
      if (!ok){ e.preventDefault(); const e1 = body.querySelector('.wfield.err input'); if(e1) e1.focus(); return; }
      state.empresa = (body.querySelector('#wEmpresa').value||'').trim();
      state.nombre  = (body.querySelector('#wNombre').value||'').trim();
      state.cargo   = (body.querySelector('#wCargo').value||'').trim();
      state.correo  = (body.querySelector('#wCorreo').value||'').trim();
      state.mensaje = (body.querySelector('#wMensaje').value||'').trim();
      // Campos derivados de las selecciones del asistente → inputs ocultos del mismo formulario
      document.getElementById('ef_interes').value = labelsOf(INTERES, state.interes);
      document.getElementById('ef_momento').value = labelsOf(MOMENTO, state.momento);
      document.getElementById('ef_tamano').value = labelOf(TAMANO, state.tamano) + ' personas';
      document.getElementById('ef_modalidad').value = labelsOf(MODALIDAD, state.modalidad);
      document.getElementById('ef_body').value = state.mensaje || 'Solicitud de propuesta para empresas (asistente web).';
      try {
        sessionStorage.setItem('psiEmpresas', JSON.stringify(state));
        sessionStorage.setItem('psiEmpresasSent', '1');
      } catch(err){}
      // sin preventDefault: envío nativo → el captcha de Shopify adjunta su token y llega el correo
    });

    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
